import { Col as e } from "../Primitives/Flex.mjs";
import { styled as t } from "styled-components";
//#region src/components/EmptyState/EmptyState.styled.ts
var n = t(e)`
    align-items: center;
    justify-content: center;
    padding: ${({ theme: e }) => e.spacing(8)};
    gap: ${({ theme: e }) => e.spacing(2)};
    border: 2px dashed ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
`, r = t.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align: e }) => e === "center" ? "center" : "flex-start"};
    text-align: ${({ $align: e }) => e === "center" ? "center" : "left"};
    padding: ${({ $compact: e }) => e ? "10px 16px 14px" : "18px 24px 22px"};
`, i = t.div`
    margin-top: 12px;
`, a = t.div`
    margin-top: 6px;
    max-width: 268px;
    text-wrap: pretty;
`, o = t.div`
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: ${({ $align: e }) => e === "center" ? "center" : "flex-start"};
    gap: ${({ theme: e }) => e.spacing(1.5)};
`;
//#endregion
export { o as ActionSlot, a as BodySlot, r as DesignedContainer, n as LegacyContainer, i as TitleSlot };
